import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customerGainLoss'
})
export class CustomerGainLossPipe implements PipeTransform {

  transform(value: any, args?: any): any {    
    if (value.charAt(0) !== '-' && value.charAt(0) !== '0') {
       return '(' + value.substring(0, value.length) + ')';
    } else {
      if (value.charAt(0) !== '0') {
         return value.substring(1, value.length)
      }
      return value;
    }   
  }
}
